<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Send to Eclipse</p>
      <button
        type="button"
        class="delete"
        v-on:click="$parent.close()"/>
    </header>
    <div class="modal-card-body">
      <b-loading active="searching"
      <form class="container" @submit.prevent="doSearch">
        <div class="field has-addons has-text-centered is-centered">
          <div class="control">
            <input type="text" class="input" name="search" v-model="searchTerm" placeholder="Bueller, Ferris">
          </div>
          <div class="control">
            <button type="submit" class="button is-default is-primary">Search Eclipse Portfolios</button>
          </div>
        </div>
      </form>


      <b-table
        v-bind:data="searchResults"
        v-if="searchResults.length > 0"
        detailed
        :detail-key="id"
        @details-open="onShowRowDetail"
        show-detail-icon
        icon-pack="fas"
      >
        <b-table-column
          field="name"
          label="Name"
          searchable
          v-slot="props"
        >
          {{ props.row.accountName }}
        </b-table-column>
        <b-table-column
          field="id"
          label="Account ID"
          searchable
          v-slot="props"
        >
          {{ props.row.accountId }}
        </b-table-column>
        <b-table-column
          field="id"
          label="Account Number"
          searchable
          v-slot="props"
        >
          {{ props.row.accountNumber }}
        </b-table-column>

        <b-table-column
          field="id"
          label="Eclipse ID"
          searchable
          v-slot="props"
        >
          {{ props.row.id }}
        </b-table-column>

        <template #detail="props">
          <div class="columns">
            <div class="column">
              <p><strong>Existing Exclusions:</strong> {{ countPrefs(props.row, 'exclusion') }}</p>
              <p><strong>Existing Inclusions:</strong> {{ countPrefs(props.row, 'inclusion') }}</p>
              <p>
                <a :href="`https://www.orioneclipse.com/#/eclipse/account/legacy/view/${props.row.id}`" target="_blank">
                  View in Eclipse
                  <b-icon
                    pack="fas"
                    icon="external-link-alt"
                  />
                </a>
              </p>
            </div>
            <div class="column has-text-right">
              <button
                class="button is-primary"
                v-on:click="sendTo(props.row)"
                :disabled="props.row.sending"
              >
                Apply{{ props.row.sending ? 'ing' : '' }} Current Screens as Security Preferences
              </button>
              <br/>
              <div class="field">
                <div class="control">
                  <label for="update">Auto Update</label>
                  <input type="checkbox" name="update" v-model="props.row.autoUpdate">
                </div>
              </div>
            </div>
          </div>
        </template>
      </b-table>


    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sending: false,
      eclipseAccounts: [],

      searchTerm: '',
      searchResults: [],
      searching: false,
    }
  },
  props: {
    exclusionSymbols: Array,
    inclusionSymbols: Array,
  },
  methods: {
    countPrefs: function(row, method) {
      let count = 0;
      if (!row.existingRestrictions) {
        return count;
      }
      row.existingRestrictions.securityPreferences.forEach((itm, idx, arr) => {
        if (method === 'exclusion' && itm.buyPriority === 1 && itm.sellPriority === 7) {
          count++;
        }
        if (method === 'inclusion' && itm.buyPriority === 5 && itm.sellPriority === 2) {
          count++;
        }
      });
      return count;
    },
    onShowRowDetail: async function(row) {
      const args = new URLSearchParams({'account_id': row.id})
      let response = await fetch(
        `/api/v1/integrations/orion/eclipse/security_restrictions/?${args}`,
        {
          method: 'GET',
        }
      );
      const results = (await response.json()).results;
      this.$set(row, 'existingRestrictions', results);

    },
    doSearch: async function() {
      this.searching = true;

      const args = new URLSearchParams({'search': this.searchTerm})
      let response = await fetch(
        `/api/v1/integrations/orion/eclipse/search/?${args}`,
        {
          method: 'GET',
        }
      );
      this.searchResults = (await response.json()).results;
      this.searching = false;
    },
    sendTo: async function(row) {
      var self = this;
      this.$set(row, 'sending', true);
      let response = await fetch(
        `/api/v1/integrations/orion/eclipse/security_restrictions/`,
        {
          method: 'POST',
          headers: {
            'X-CSRFToken': this.$root.$data.csrfToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            account_id: row.id,
            exclusion_ticker_symbols: this.exclusionSymbols,
            inclusion_ticker_symbols: this.inclusionSymbols,
          })
        }
      );
      let data = await response.json();
      let interval = window.setInterval(async function() {
        let taskResponse = await fetch(`/api/v1/tasks/${data.background_task_id}/`);
        let taskData = await taskResponse.json();
        if (taskData.task.status !== 'pending'){
          row.sending = false;
          if (taskData.task.status === 'failed') {
            self.$buefy.dialog.alert(
              `There was an error applying screens to ${row.name} (#${row.id}), please try again. If this problem persists, contact us at support@yourstake.org.`
            );
          }
          else {
            self.$buefy.dialog.alert(
              `Successfully applied screens to ${row.name} (#${row.id})`
            );
          }

          window.clearInterval(interval);
        }
      }, 1500);
    },
  },
  mounted: async function() {
  }
}
</script>

<style scoped>
  .modal-content, .modal-card {
    width: 1000px !important;
  }
  .animation-content {
    max-width: 1000px !important;
  }
</style>
